@if (showNavbar) {
    <app-navbar [(showMenu)]="showMenu" />
}
@if (showNavbar) {
    <app-left-menu [(isVisible)]="showMenu" />
}
<app-loader [show]="showLoader"></app-loader>

<main>
    <div>
        <router-outlet />
    </div>
</main>
